import React from "react";

const AccessDeniedPage = () => (
    <div className="p-20">
        <h1>Access Denied</h1>
        <p>You do not have permissions to perform any action on the Customer Manager app.
            Ask your supervisor to add you some.
        </p>
    </div>
);

export default AccessDeniedPage;